'use strict';

goog.provide("Ntry.MazeStaticResult");

goog.require("Ntry.STATIC");
goog.require("Ntry.Engine");

Ntry.MazeStaticResult = function() {
    this._completePopup = new entrylms.Modal();
};

(function(p) {
    p.loadConfig = function() {
        Ntry.addEventListener("complete", this, this.complete);
    };

    p.complete = function(success, cause) {
        var stageId = Ntry.configManager.getConfig("stageId");
        var modeId = Ntry.configManager.getConfig("modeId");
        var isHomework = Ntry.configManager.getConfig("isHomework");
        var isHomeworkLapse = Ntry.configManager.getConfig("isHomeworkLapse");
        var isLastStudy = Ntry.configManager.getConfig("isLastStudy");
        var completeData = {};

        if(success) {
            if (this.inspectEssential(modeId)) {
                completeData = getSuccessContent(modeId, stageId);
                completeData.titleType = 'SUCCESS';
                completeData.title = Lang.Menus.success + '!';
            } else {
                completeData = getFailContent(modeId, stageId, Ntry.STATIC.ESSENTIAL_REQUIRED);
                completeData.titleType = 'FAIL';
                completeData.title = Lang.Menus.fail;
            }
        } else {
            completeData = getFailContent(modeId, stageId, cause);
            completeData.titleType = 'FAIL';
            completeData.title = Lang.Menus.fail;
        }

        var modalData = {
            type: 'COMPLETE',
            title: completeData.title,
            titleType: completeData.titleType,
            isHomework: isHomework,
            isHomeworkLapse: isHomeworkLapse,
            isLastStudy: isLastStudy,
            buttons:[{
                text: Lang.Menus.replay,
                click: function (e) {
                    this._completePopup.hide();
                    Ntry.dispatchEvent("replay");
                }.bind(this)
            }],
            content: completeData.content,
        }

        if(completeData.media) {
            modalData.media = completeData.media;
        }
        this._completePopup.modalData = modalData;
        this._completePopup.off('click').on('click', function (type) {
            if(type === 'prev') {
                Ntry.dispatchEvent("replay");
                return;
            }

            var code = getUserCode();
            if (code)
                code = code.toJSON();

            var submitType = 'ExitStudy';
            if((isHomework && !isHomeworkLapse) || type == 'submit') {
                submitType = 'SubmitStudy';
            }
            entrylms.emit(submitType, {
                type: 'mazeStatic',
                value: {code:code}
            });
        });
        this._completePopup.show();
    };

    function getSuccessContent(modeId, stageId) {
        var limitBlockCnt = Ntry.configManager.getConfig("limitBlockCnt");
        var usedBlockCnt = currentUsedBlock();
        var completeData = {};
        if(modeId == 1)  {
            if (usedBlockCnt <= limitBlockCnt) {
                completeData.titleType = 'FINISH';
                if (stageId != 15) {
                    completeData.content = Lang.Menus.jr_popup_prefix_3;
                } else {
                    completeData.content = Lang.Menus.jr_popup_suffix_1;
                }
            } else if (usedBlockCnt > limitBlockCnt) {
                completeData.titleType = 'INCOMPLETE';
                completeData.content = Lang.Menus.jr_popup_prefix_4;
            }
        } else if(modeId == 2) {
            usedBlockCnt += 1;
            if (usedBlockCnt <= limitBlockCnt) {
                completeData.titleType = 'FINISH';
                if (stage == 12) {
                    completeData.content = Lang.Menus.cparty_result_success_3;
                } else {
                    completeData.content = Lang.Menus.cparty_result_success_1;
                }
            } else if (usedBlockCnt > limitBlockCnt) {
                completeData.titleType = 'INCOMPLETE';
                completeData.content = Lang.Menus.cparty_result_success_2;
            }
        } else if(modeId == 3) {
            var stage = Number(stageId) + 12;
            usedBlockCnt += 1;
            if (usedBlockCnt <= limitBlockCnt) {
                completeData.titleType = 'FINISH';
                if (stage != 22) {
                    completeData.content = Lang.Menus.cparty_car_popup_prefix_1;
                } else {
                    completeData.content = Lang.Menus.cparty_car_popup_suffix;
                }
            } else if (usedBlockCnt > limitBlockCnt) {
                completeData.titleType = 'INCOMPLETE';
                completeData.content = Lang.Menus.cparty_car_popup_prefix_2;
            }
        } else if(modeId == 5) {
            var usedBlockCnt = 0;
            var code = getUserCode();
            if (code) {
                var startThread = code.getEventMap('start')[0].getThread();
                var usedBlockCnt = startThread.countBlock();
                var defineThread = code.getEventMap('define');
                if (defineThread && defineThread[0]) {
                    defineThread = defineThread[0].getThread();
                    usedBlockCnt += defineThread.countBlock();
                }
            }

            if (usedBlockCnt === limitBlockCnt) {
                completeData.titleType = 'FINISH';
                completeData.content = [Lang.Menus.perfect, usedBlockCnt, Lang.Menus.succeeded_using_blocks].join(' ');
            } else if (usedBlockCnt < limitBlockCnt) {
                completeData.titleType = 'INCOMPLETE';
                completeData.content = [Lang.Menus.awesome, usedBlockCnt, Lang.Menus.succeeded_go_to_next].join(' ');
            } else {
                completeData.titleType = 'INCOMPLETE';
                completeData.content = [Lang.Menus.good, usedBlockCnt, Lang.Menus.succeeded_using_blocks, Lang.Menus.but, limitBlockCnt, Lang.Menus.try_again].join(' ');
            }
        }

        return completeData;
    }

    function getFailContent(modeId, stageId, cause) {
        var result = {};

        if(modeId == 1) {
            var causeMsgs = [
                Lang.Menus.jr_fail_dont_know,
                Lang.Menus.jr_fail_dont_go,
                Lang.Menus.jr_fail_no_pencil,
                Lang.Menus.jr_fail_forgot_pencil,
                Lang.Menus.jr_fail_need_repeat,
                Lang.Menus.jr_fail_much_blocks,
            ]

            switch (cause) {
                case Ntry.STATIC.SIMOOROOK:
                    result.content = causeMsgs[0];
                    break;
                case Ntry.STATIC.GET_ITEM:
                    result.content = causeMsgs[2];
                    break;
                case Ntry.STATIC.WITHOUT_ITEM_SUCCESS:
                    result.content = causeMsgs[3];
                    break;
                case Ntry.STATIC.ESSENTIAL_REQUIRED:
                    result.content = causeMsgs[4];
                    break;
                case Ntry.STATIC.OVER_LIMITED_BLOCK:
                case Ntry.STATIC.NO_ITEM:
                    result.content = causeMsgs[5];
                    break;
                case Ntry.STATIC.WALL_CRASH:
                default:
                    result.content = causeMsgs[1];
                    break;
            }
        } else if(modeId == 2 || modeId == 3) {
            var causeMsgs = [
                Lang.Menus.cparty_result_fail_1,
                Lang.Menus.cparty_result_fail_2,
                Lang.Menus.cparty_result_fail_3,
                Lang.Menus.cparty_result_fail_4,
                Lang.Menus.cparty_result_fail_5
            ];

            switch (cause) {
                case Ntry.STATIC.WALL_CRASH:
                    result.content = causeMsgs[0];
                    break;
                case Ntry.STATIC.BEE_ATTACK:
                case Ntry.STATIC.ELECTRIC_SHOCK:
                case Ntry.STATIC.SLIP:
                    result.content = causeMsgs[1];
                    break;
                case Ntry.STATIC.ESSENTIAL_REQUIRED:
                    result.content = causeMsgs[2];
                    result.media = {
                        category: 'IMAGE',
                        content: getBlockImage(modeId, stageId, true),
                    }
                    break;
                case Ntry.STATIC.GO_SLOW_CRASH:
                    result.content = causeMsgs[4];
                    result.media = {
                        category: 'IMAGE',
                        content: getBlockImage(modeId, stageId),
                    }
                    break;
                case Ntry.STATIC.SIMOOROOK:
                default:
                    result.content = causeMsgs[3];
                    break;
            }
        } else if(modeId == 5) {
            var causeMsgs = [
                Lang.Menus.cause_msgs_1,
                Lang.Menus.cause_msgs_2,
                Lang.Menus.cause_msgs_3,
                Lang.Menus.cause_msgs_4,
                Lang.Menus.cause_msgs_5,
                Lang.Menus.cause_msgs_6
            ]

            switch (cause) {
                case Ntry.STATIC.WALL_CRASH:
                    result.content = causeMsgs[0];
                break;
                case Ntry.STATIC.JUMP:
                    result.content = causeMsgs[1];
                    break;
                case Ntry.STATIC.BEE_ATTACK:
                case Ntry.STATIC.ELECTRIC_SHOCK:
                case Ntry.STATIC.SLIP:
                    result.content = causeMsgs[2];
                    break;
                case Ntry.STATIC.ESSENTIAL_REQUIRED:
                    result.content = causeMsgs[3];
                    result.media = {
                        category: 'IMAGE',
                        content: getBlockImage(modeId, stageId),
                    }
                    break;
                case Ntry.STATIC.SIMOOROOK:
                default:
                    result.content = causeMsgs[4];
                    break;
            }
        }

        return result;
    }

    function getBlockImage(modeId, stageId, isEssential) {
        var image = '';

        if(modeId == 3) {
            if(isEssential) {
                if(stageId > 12) {
                    stageId = stageId %12;
                    switch (stageId) {
                        case 4:
                        case 5:
                            if(Lang.type == 'en') {
                                image = '/img/assets/codingparty/essentials/en/4_5.png';
                            } else {
                                image = '/img/assets/codingparty/essentials/4_5.png';
                            }
                        break;
                        case 6:
                        case 7:
                            if(Lang.type == 'en') {
                                image = '/img/assets/codingparty/essentials/en/6_7.png';
                            } else {
                                image = '/img/assets/codingparty/essentials/6_7.png';
                            }
                        break;
                        case 8:
                            if(Lang.type == 'en') {
                                image = '/img/assets/codingparty/essentials/en/8.png';
                            } else {
                                image = '/img/assets/codingparty/essentials/8.png';
                            }
                        break;
                        case 9:
                        case 10:
                            if(Lang.type == 'en') {
                                image = '/img/assets/codingparty/essentials/en/9_10.png';
                            } else {
                                image = '/img/assets/codingparty/essentials/9_10.png';
                            }
                        break;
                    }
                } else
                    image = '/img/assets/ntry/essentials/7_8.png';
            } else {
                image = '/img/assets/ntry/essentials/cparty/slow_1.png';
            }
        } else if(modeId == 5) {
            if (stageId == 1 || stageId == 2) {
                image = '/img/assets/ntry/essentials/7_8.png';
            } else if (stageId == 3) {
                image = '/img/assets/ntry/essentials/9.png';
            } else if (stageId >= 4 && stageId <= 6) {
                image = '/img/assets/ntry/essentials/10_11_12.png';
            } else if (stageId == 7 || stageId == 8){
                image = '/img/assets/ntry/essentials/13_14.png';
            } else {
                image = '/img/assets/ntry/essentials/15-20.png'
            }

        }

        return image;
    }

    p.inspectEssential = function(mode) {
        var essentialBlock = Ntry.configManager.getConfig('essentialBlock');
        if (essentialBlock === undefined) return true;

        var code = getUserCode();
        if (_.isEmpty(code)) return false;

        var threads = code.getThreads();
        if (_.isEmpty(threads)) return false;

        var ret = false;

        if(mode == 1) {
            for(var i = 0, len = threads.length; i < len; i++) {
                var thread = threads[i];
                var head = thread.getFirstBlock();

                if (!head || !head._schema.event) continue;

                var blocks = thread.getBlocks();
                for (var j=0; j<blocks.length; j++) {
                    var type = blocks[j].type;
                    if (type == 'jr_repeat') {
                        ret = true;
                        break;
                    }
                }
            }
        } else if(mode == 3) {
            var esBlocks = essentialBlock.blocks.slice(0);

            var index = -1;
            for (var i=0; i<blocks.length; i++) {
                index = esBlocks.indexOf(blocks[i].type);
                if (index > -1) esBlocks.splice(index, 1);

                if (esBlocks.length === 0)  {
                    ret = true;
                }
            }
        } else if(mode == 5) {
            var esBlocks = essentialBlock.blocks.slice(0);

            for (var i = 0, len = threads.length; i < len; i++) {
                var thread = threads[i];
                var head = thread.getFirstBlock(); //첫번째 Thread (jrstart)

                if (!head || !head._schema.event) {
                    continue;
                }

                var blocks = thread.getBlocks();

                for (var j = 0; j < blocks.length; j++) {
                    var block = blocks[j];
                    var type = block.type;

                    var index = esBlocks.indexOf(type);
                    if (index > -1) {
                        esBlocks.splice(index, 1);
                    }
                    var statement = block.statements[0];
                    if (statement) {
                        var innerBlocks = statement.getBlocks();
                        for (var k = 0; k < innerBlocks.length; k++) {
                            var innerBlock = innerBlocks[k];
                            type = innerBlock.type;

                            index = esBlocks.indexOf(type);
                            if (index > -1) {
                                esBlocks.splice(index, 1);
                            }
                        }
                    }

                    if (esBlocks.length === 0) {
                        ret = true;
                    }
                }
            }
        }

        return ret;
    };

    function getUserCode() {
        var entities = Ntry.entityManager.getEntitiesByComponent(Ntry.STATIC.CODE);
        var entity = entities[Object.keys(entities)[0]];

        if (entity) {
            return Ntry.entityManager.getComponent(entity.id, Ntry.STATIC.CODE).code;
        }
    };

    function currentUsedBlock() {
        var code = getUserCode();

        if (code) {
            return code.getEventMap('start')[0].getThread().countBlock()-1;
        }
    };

})(Ntry.MazeStaticResult.prototype);
